const getTableData = ({table1, table2}) => {
    // const table_us = data?.station_table_us
    // const table_ds = data?.station_table_ds

    const cp_table1 = [...table1]
    const cp_table2 = [...table2]

    const diff = cp_table1?.length > cp_table2?.length;
    if(diff > 0) {
        for (let i=0; i<diff; i++) {
            cp_table1?.push([])
        }
    }
    else {
        for (let i=0; i<Math.abs(diff); i++) {
            cp_table2?.push([])
        }
    }

    for(let i=0; i<cp_table1.length; i++) {
        const ds = cp_table2[i] || []
        cp_table1[i] = [...cp_table1[i], ...ds]
    }

    return cp_table1
}

const setStyleForInput = ({targetWindow, windowName, name}) => {
    if(!targetWindow)
        return

    const id = `${targetWindow}-${name}`
    const elementBase = document.getElementById(id)
    const elementCmp = document.getElementById(`${windowName}-${name}`)

    if(elementCmp)
        elementCmp.style.color = 'black'
    if(elementBase && elementCmp) {
        if(elementBase.innerText !== elementCmp.innerText && parseFloat(elementBase.innerText) !== parseFloat(elementCmp.innerText))
            elementCmp.style.color = 'red'
    }
}

const setStyleForRadio = ({targetWindow, windowName, name}) => {
    if(!targetWindow)
        return

    const base_radio_id = `${targetWindow}-${name}-radio`
    const cmp_radio_id = `${windowName}-${name}-radio`
    const baseVal = document.querySelector(`input[name=${base_radio_id}]:checked`)?.value
    const cmpVal = document.querySelector(`input[name=${cmp_radio_id}]:checked`)?.value

    const element = document.getElementById(`${windowName}-${name}`);
    if(element) {
        if(baseVal !== cmpVal) {
            element.style.color = 'red'
        }
        else {
            element.style.color = 'black'
        }
    }
}


const setStyleForCheckbox = ({targetWindow, windowName, name}) => {
    if(!targetWindow)
        return

    try {
        const base_cb_id = `${targetWindow}-${name}-checkbox`
        const cmp_cb_id = `${windowName}-${name}-checkbox`
        const baseVals = document.querySelectorAll(`input[name=${base_cb_id}]:checked`)
        const cmpVals = document.querySelectorAll(`input[name=${cmp_cb_id}]:checked`)

        const element = document.getElementById(`${windowName}-${name}`);
        if(element) {
            if(baseVals?.length !== cmpVals?.length) {
                element.style.color = 'red'
            }
            else if(baseVals?.length === cmpVals?.length && baseVals?.length > 0) {
                if(!baseVals?.find(x => cmpVals?.find(y => y.value === x.value))) {
                    element.style.color = 'red'
                }
                // baseVals.length !== cmpVals.length
            }
            else {
                element.style.color = 'black'
            }
        }
    }
    catch (exp) {
        console.log(exp)
    }
}

const setStyleForTable = ({targetWindow, windowName, name, skipIndex}=[]) => {
    if(!targetWindow)
        return

    const base_tbody = document.getElementById(`${targetWindow}-${name}`)
    const cmp_tbody = document.getElementById(`${windowName}-${name}`)
    if(base_tbody && cmp_tbody) {
        for(let i=0; i<cmp_tbody.rows.length; i++) {
            const row = cmp_tbody.rows[i]
            for(let m=0; m<row.cells.length; m++) {
                if(skipIndex.findIndex(x => x === m) >= 0)
                    continue

                const cell = row.cells[m]
                if(cell.innerText !== base_tbody.rows[i]?.cells[m]?.innerText)
                    cell.style.color = 'red'
                else
                    cell.style.color = 'black'
            }
        }
    }
}


const UIComponentHelper = {
    getTableData,
    setStyleForInput,
    setStyleForRadio,
    setStyleForCheckbox,
    setStyleForTable
}

export default UIComponentHelper;